<template>
    <div
        class="w-100 "
        :class="border ? 'lm-border pa-2 pr-6' : ''"
        style="height: 200px;"
    >
        <div
            :class="border ? 'ma-2' : 'ma-0'"
            v-html="text"
        >
        </div>
    </div>
</template>

<script>
export default {
    name: "SiteTzbNote",

    props: {
        note: {
            default: function () {
                return "";
            }
        },

        border: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        }
    },

    computed: {
        text () {
            if (!this.note) {
                return "";
            }

            return this.note.replaceAll ("\\n", "<br>");
        }
    }
}
</script>

<style scoped>

</style>le>